import { computed, type Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AbstractControl } from '@angular/forms';
import { map } from 'rxjs';

/**
 * Formulaire lu par un gabarit OnPush sans zone : le signal rendu notifie à chaque validation,
 * et le gabarit réévalue alors `hasError`, `valid` ou `disabled` sur le formulaire lui-même.
 * À appeler dans un contexte d'injection (initialiseur de champ ou constructeur).
 */
export function suivreFormulaire<T extends AbstractControl>(formulaire: T): Signal<T> {
  const validations = toSignal(formulaire.statusChanges.pipe(map((_, index) => index)), { initialValue: -1 });

  return computed(
    () => {
      validations();
      return formulaire;
    },
    { equal: () => false },
  );
}
